// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./hotlist.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PAGE */

.e2e_jobs_page{

  background:#ffffff;

  padding:26px;

  border-radius:24px;

  border:1px solid #edf2f7;

  box-shadow:
    0 10px 35px rgba(15,23,42,0.06);
}

/* TOP */

.e2e_jobs_top{

  display:flex;

  justify-content:space-between;

  align-items:center;

  margin-bottom:28px;

  gap:20px;

  flex-wrap:wrap;
}

/* TITLE */

.e2e_jobs_left h2{

  font-size:28px;

  font-weight:800;

  color:#0f172a;

  margin:0;
}

/* UNDERLINE */

.e2e_jobs_heading_line{

  width:95px;

  height:5px;

  margin-top:12px;

  border-radius:30px;

  background:
    linear-gradient(
      90deg,
      #2563eb,
      #7c3aed
    );
}

/* BUTTON */

.e2e_jobs_right button{

  border:none;

  background:
    linear-gradient(
      135deg,
      #1677ff,
      #2563eb
    );

  color:white;

  height:46px;

  padding:0 24px;

  border-radius:14px;

  font-size:14px;

  font-weight:700;

  cursor:pointer;

  transition:0.3s ease;
}

/* FILTERS */

.e2e_jobs_filters{

  background:#f8fafc;

  border:1px solid #edf2f7;

  border-radius:20px;

  padding:20px 22px;

  display:flex;

  justify-content:space-between;

  align-items:center;

  gap:24px;

  margin-bottom:28px;
}

/* LEFT */

.e2e_jobs_filter_left{

  display:flex;

  align-items:center;

  gap:18px;

  flex-wrap:wrap;
}

/* GROUP */

.e2e_jobs_filter_group{

  display:flex;

  align-items:center;

  gap:10px;
}

.e2e_jobs_filter_group label{

  font-size:14px;

  font-weight:700;

  color:#334155;
}

.e2e_jobs_filter_group span{

  font-size:14px;

  font-weight:600;

  color:#64748b;
}

/* SELECT */

.e2e_jobs_filter_group select{

  height:46px;

  min-width:200px;

  padding:0 16px;

  border:1px solid #dbe2ea;

  border-radius:14px;

  background:white;

  font-size:14px;

  font-weight:600;
}

/* SMALL */

.smallSelect{

  min-width:90px !important;
}

/* REPORT */

.e2e_jobs_report_btn{

  height:46px;

  border:none;

  background:
    linear-gradient(
      135deg,
      #06b6d4,
      #0891b2
    );

  color:white;

  padding:0 22px;

  border-radius:14px;

  font-size:14px;

  font-weight:700;

  cursor:pointer;
}

/* SEARCH */

.e2e_jobs_filter_right input{

  width:320px;

  height:46px;

  padding:0 18px;

  border:1px solid #dbe2ea;

  border-radius:14px;

  background:white;
}

/* TABLE */

.e2e_jobs_table_wrapper{

  overflow-x:auto;
}

.e2e_jobs_table_wrapper table{

  width:100%;

  border-collapse:separate;

  border-spacing:0 14px;
}

/* HEAD */

.e2e_jobs_table_wrapper thead th{

  background:#f8fafc;

  padding:18px;

  font-size:13px;

  font-weight:800;

  text-transform:uppercase;

  color:#475569;
}

/* ROW */

.e2e_jobs_table_wrapper tbody tr{

  background:white;

  box-shadow:
    0 4px 15px rgba(15,23,42,0.04);
}

/* CELLS */

.e2e_jobs_table_wrapper td{

  padding:20px 18px;

  vertical-align:middle;

  font-size:14px;

  font-weight:600;

  border-top:1px solid #f1f5f9;

  border-bottom:1px solid #f1f5f9;
}

/* WIDTHS */

.e2e_jobs_table_wrapper td:nth-child(1){

  width:60px;

  text-align:center;

  color:#2563eb;

  font-weight:800;
}

.e2e_jobs_table_wrapper td:nth-child(2){

  width:32%;
}

.e2e_jobs_table_wrapper td:nth-child(3){

  width:25%;
}

.e2e_jobs_table_wrapper td:nth-child(4){

  width:28%;
}

.e2e_jobs_table_wrapper td:nth-child(5){

  width:150px;
}

/* DETAILS */

.e2e_jobs_details{

  line-height:1.7;
}

.e2e_jobs_details strong{

  margin-left:6px;
}

/* ACTIONS */

.e2e_jobs_actions{

  display:flex;

  align-items:center;

  gap:10px;
}

/* BUTTONS */

.viewBtn,
.editBtn,
.deleteBtn{

  border:none;

  width:80px;

  height:38px;

  border-radius:10px;

  font-size:12px;

  font-weight:700;

  cursor:pointer;
}

.viewBtn{

  background:#dbeafe;

  color:#2563eb;
}

.editBtn{

  background:#fef3c7;

  color:#d97706;
}

.deleteBtn{

  background:#fee2e2;

  color:#dc2626;
}`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard/jobs.css"],"names":[],"mappings":"AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,kBAAkB;;EAElB,wBAAwB;;EAExB;mCACiC;AACnC;;AAEA,QAAQ;;AAER;;EAEE,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;;EAEb,QAAQ;AACV;;AAEA,cAAc;;AAEd;;EAEE,UAAU;;EAEV,UAAU;;EAEV,eAAe;;EAEf,kBAAkB;;EAElB;;;;;KAKG;AACL;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;;EAEd,oBAAoB;AACtB;;AAEA,YAAY;;AAEZ;;EAEE,kBAAkB;;EAElB,wBAAwB;;EAExB,kBAAkB;;EAElB,iBAAiB;;EAEjB,YAAY;;EAEZ,6BAA6B;;EAE7B,kBAAkB;;EAElB,QAAQ;;EAER,kBAAkB;AACpB;;AAEA,SAAS;;AAET;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;;EAER,cAAc;AAChB;;AAEA,UAAU;;AAEV;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA;;EAEE,cAAc;;EAEd,eAAe;;EAEf,aAAa;AACf;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,eAAe;;EAEf,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,gBAAgB;;EAEhB,cAAc;;EAEd,eAAe;AACjB;;AAEA,UAAU;;AAEV;;EAEE,yBAAyB;AAC3B;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,WAAW;;EAEX;;;;;KAKG;;EAEH,WAAW;;EAEX,cAAc;;EAEd,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;AAChB;;AAEA,WAAW;;AAEX;;EAEE,WAAW;;EAEX,WAAW;;EAEX,cAAc;;EAEd,wBAAwB;;EAExB,kBAAkB;;EAElB,gBAAgB;AAClB;;AAEA,UAAU;;AAEV;;EAEE,eAAe;AACjB;;AAEA;;EAEE,UAAU;;EAEV,wBAAwB;;EAExB,qBAAqB;AACvB;;AAEA,SAAS;;AAET;;EAEE,kBAAkB;;EAElB,YAAY;;EAEZ,cAAc;;EAEd,eAAe;;EAEf,wBAAwB;;EAExB,aAAa;AACf;;AAEA,QAAQ;;AAER;;EAEE,gBAAgB;;EAEhB;kCACgC;AAClC;;AAEA,UAAU;;AAEV;;EAEE,iBAAiB;;EAEjB,qBAAqB;;EAErB,cAAc;;EAEd,eAAe;;EAEf,4BAA4B;;EAE5B,+BAA+B;AACjC;;AAEA,WAAW;;AAEX;;EAEE,UAAU;;EAEV,iBAAiB;;EAEjB,aAAa;;EAEb,eAAe;AACjB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA,YAAY;;AAEZ;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA,YAAY;;AAEZ;;EAEE,YAAY;;EAEZ,kBAAkB;;EAElB,QAAQ;AACV;;AAEA,YAAY;;AAEZ;;;;EAIE,WAAW;;EAEX,UAAU;;EAEV,WAAW;;EAEX,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;;EAEf,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;;EAElB,aAAa;AACf","sourcesContent":["@import \"./hotlist.css\";\r\n\r\n/* PAGE */\r\n\r\n.e2e_jobs_page{\r\n\r\n  background:#ffffff;\r\n\r\n  padding:26px;\r\n\r\n  border-radius:24px;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  box-shadow:\r\n    0 10px 35px rgba(15,23,42,0.06);\r\n}\r\n\r\n/* TOP */\r\n\r\n.e2e_jobs_top{\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  margin-bottom:28px;\r\n\r\n  gap:20px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* TITLE */\r\n\r\n.e2e_jobs_left h2{\r\n\r\n  font-size:28px;\r\n\r\n  font-weight:800;\r\n\r\n  color:#0f172a;\r\n\r\n  margin:0;\r\n}\r\n\r\n/* UNDERLINE */\r\n\r\n.e2e_jobs_heading_line{\r\n\r\n  width:95px;\r\n\r\n  height:5px;\r\n\r\n  margin-top:12px;\r\n\r\n  border-radius:30px;\r\n\r\n  background:\r\n    linear-gradient(\r\n      90deg,\r\n      #2563eb,\r\n      #7c3aed\r\n    );\r\n}\r\n\r\n/* BUTTON */\r\n\r\n.e2e_jobs_right button{\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #1677ff,\r\n      #2563eb\r\n    );\r\n\r\n  color:white;\r\n\r\n  height:46px;\r\n\r\n  padding:0 24px;\r\n\r\n  border-radius:14px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n\r\n  transition:0.3s ease;\r\n}\r\n\r\n/* FILTERS */\r\n\r\n.e2e_jobs_filters{\r\n\r\n  background:#f8fafc;\r\n\r\n  border:1px solid #edf2f7;\r\n\r\n  border-radius:20px;\r\n\r\n  padding:20px 22px;\r\n\r\n  display:flex;\r\n\r\n  justify-content:space-between;\r\n\r\n  align-items:center;\r\n\r\n  gap:24px;\r\n\r\n  margin-bottom:28px;\r\n}\r\n\r\n/* LEFT */\r\n\r\n.e2e_jobs_filter_left{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:18px;\r\n\r\n  flex-wrap:wrap;\r\n}\r\n\r\n/* GROUP */\r\n\r\n.e2e_jobs_filter_group{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n.e2e_jobs_filter_group label{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  color:#334155;\r\n}\r\n\r\n.e2e_jobs_filter_group span{\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  color:#64748b;\r\n}\r\n\r\n/* SELECT */\r\n\r\n.e2e_jobs_filter_group select{\r\n\r\n  height:46px;\r\n\r\n  min-width:200px;\r\n\r\n  padding:0 16px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:14px;\r\n\r\n  background:white;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n}\r\n\r\n/* SMALL */\r\n\r\n.smallSelect{\r\n\r\n  min-width:90px !important;\r\n}\r\n\r\n/* REPORT */\r\n\r\n.e2e_jobs_report_btn{\r\n\r\n  height:46px;\r\n\r\n  border:none;\r\n\r\n  background:\r\n    linear-gradient(\r\n      135deg,\r\n      #06b6d4,\r\n      #0891b2\r\n    );\r\n\r\n  color:white;\r\n\r\n  padding:0 22px;\r\n\r\n  border-radius:14px;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n}\r\n\r\n/* SEARCH */\r\n\r\n.e2e_jobs_filter_right input{\r\n\r\n  width:320px;\r\n\r\n  height:46px;\r\n\r\n  padding:0 18px;\r\n\r\n  border:1px solid #dbe2ea;\r\n\r\n  border-radius:14px;\r\n\r\n  background:white;\r\n}\r\n\r\n/* TABLE */\r\n\r\n.e2e_jobs_table_wrapper{\r\n\r\n  overflow-x:auto;\r\n}\r\n\r\n.e2e_jobs_table_wrapper table{\r\n\r\n  width:100%;\r\n\r\n  border-collapse:separate;\r\n\r\n  border-spacing:0 14px;\r\n}\r\n\r\n/* HEAD */\r\n\r\n.e2e_jobs_table_wrapper thead th{\r\n\r\n  background:#f8fafc;\r\n\r\n  padding:18px;\r\n\r\n  font-size:13px;\r\n\r\n  font-weight:800;\r\n\r\n  text-transform:uppercase;\r\n\r\n  color:#475569;\r\n}\r\n\r\n/* ROW */\r\n\r\n.e2e_jobs_table_wrapper tbody tr{\r\n\r\n  background:white;\r\n\r\n  box-shadow:\r\n    0 4px 15px rgba(15,23,42,0.04);\r\n}\r\n\r\n/* CELLS */\r\n\r\n.e2e_jobs_table_wrapper td{\r\n\r\n  padding:20px 18px;\r\n\r\n  vertical-align:middle;\r\n\r\n  font-size:14px;\r\n\r\n  font-weight:600;\r\n\r\n  border-top:1px solid #f1f5f9;\r\n\r\n  border-bottom:1px solid #f1f5f9;\r\n}\r\n\r\n/* WIDTHS */\r\n\r\n.e2e_jobs_table_wrapper td:nth-child(1){\r\n\r\n  width:60px;\r\n\r\n  text-align:center;\r\n\r\n  color:#2563eb;\r\n\r\n  font-weight:800;\r\n}\r\n\r\n.e2e_jobs_table_wrapper td:nth-child(2){\r\n\r\n  width:32%;\r\n}\r\n\r\n.e2e_jobs_table_wrapper td:nth-child(3){\r\n\r\n  width:25%;\r\n}\r\n\r\n.e2e_jobs_table_wrapper td:nth-child(4){\r\n\r\n  width:28%;\r\n}\r\n\r\n.e2e_jobs_table_wrapper td:nth-child(5){\r\n\r\n  width:150px;\r\n}\r\n\r\n/* DETAILS */\r\n\r\n.e2e_jobs_details{\r\n\r\n  line-height:1.7;\r\n}\r\n\r\n.e2e_jobs_details strong{\r\n\r\n  margin-left:6px;\r\n}\r\n\r\n/* ACTIONS */\r\n\r\n.e2e_jobs_actions{\r\n\r\n  display:flex;\r\n\r\n  align-items:center;\r\n\r\n  gap:10px;\r\n}\r\n\r\n/* BUTTONS */\r\n\r\n.viewBtn,\r\n.editBtn,\r\n.deleteBtn{\r\n\r\n  border:none;\r\n\r\n  width:80px;\r\n\r\n  height:38px;\r\n\r\n  border-radius:10px;\r\n\r\n  font-size:12px;\r\n\r\n  font-weight:700;\r\n\r\n  cursor:pointer;\r\n}\r\n\r\n.viewBtn{\r\n\r\n  background:#dbeafe;\r\n\r\n  color:#2563eb;\r\n}\r\n\r\n.editBtn{\r\n\r\n  background:#fef3c7;\r\n\r\n  color:#d97706;\r\n}\r\n\r\n.deleteBtn{\r\n\r\n  background:#fee2e2;\r\n\r\n  color:#dc2626;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
